<template>
  <div class="fluxo-tipo-etapa-chips">
    <v-chip
      v-for="item in items"
      :key="getValue(item)"
      small
      label
      class="fluxo-tipo-etapa-chip"
      :class="{ 'fluxo-tipo-etapa-chip--active': isActive(getValue(item)) }"
      :style="getChipStyle(item)"
      @click="toggle(getValue(item))"
    >
      <v-icon v-if="isActive(getValue(item))" left small>mdi-check</v-icon>
      <span class="fluxo-tipo-etapa-chip__label">{{ getLabel(item) }}</span>
      <span class="fluxo-tipo-etapa-chip__badge">{{ item.count }}</span>
    </v-chip>
  </div>
</template>

<script>
const LABELS_EXIBICAO = { Falha: "Pendência" };

export default {
  name: "FluxoTipoEtapaChips",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getValue(item) {
      return item.value !== undefined ? item.value : item.label;
    },
    getLabel(item) {
      return LABELS_EXIBICAO[item.label] || item.label;
    },
    isActive(label) {
      return this.value.includes(label);
    },
    toggle(label) {
      const next = [...this.value];
      const index = next.indexOf(label);

      if (index > -1) {
        next.splice(index, 1);
      } else {
        next.push(label);
      }

      this.$emit("input", next);
      this.$emit("change", next);
    },
    getChipStyle(item) {
      const color = item.color || "#607d8b";
      const active = this.isActive(this.getValue(item));

      return {
        backgroundColor: active ? color : this.hexToRgba(color, 0.08),
        borderColor: active ? color : this.hexToRgba(color, 0.22),
        color: active ? this.getTextColor(color) : "#64748b",
      };
    },
    getTextColor(hexColor) {
      return this.isColorDark(hexColor) ? "#ffffff" : "#0f172a";
    },
    isColorDark(hexColor) {
      if (!hexColor || !String(hexColor).startsWith("#")) return true;

      const hex = String(hexColor).replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      if ([r, g, b].some((value) => Number.isNaN(value))) return true;

      return (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.5;
    },
    hexToRgba(hexColor, alpha = 1) {
      if (!hexColor || !String(hexColor).startsWith("#")) {
        return hexColor || "#f8fafc";
      }

      const hex = String(hexColor).replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      if ([r, g, b].some((value) => Number.isNaN(value))) {
        return hexColor;
      }

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },
};
</script>

<style scoped>
.fluxo-tipo-etapa-chips {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 2px 0;
}

.fluxo-tipo-etapa-chip {
  border: 1px solid currentColor !important;
  border-radius: 999px !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
  font-size: 12px;
  font-weight: 600;
  height: 30px !important;
  margin: 0 !important;
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    border-color 0.15s ease;
}

.fluxo-tipo-etapa-chip:hover {
  border-color: #94a3b8 !important;
  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.08) !important;
  transform: translateY(-1px);
}

.fluxo-tipo-etapa-chip--active {
  border-color: transparent !important;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.14) !important;
}

.fluxo-tipo-etapa-chip__label {
  line-height: 1;
}

.fluxo-tipo-etapa-chip__badge {
  align-items: center;
  background: rgba(100, 116, 139, 0.12);
  border-radius: 999px;
  display: inline-flex;
  font-size: 10px;
  font-weight: 700;
  height: 18px;
  justify-content: center;
  margin-left: 8px;
  min-width: 20px;
  padding: 0 6px;
}

.fluxo-tipo-etapa-chip--active .fluxo-tipo-etapa-chip__badge {
  background: rgba(255, 255, 255, 0.24);
  color: inherit;
}
</style>
